export default class FormRegister {

    constructor($view) {
        this.H_ERROR = 'google_error';
        this.ERROR_MESSAGE = 'Il y a déjà un compte FRANSAT qui existe avec ce compte Google';
        this.ERROR_MESSAGE_ALREADY_EXIST = 'Il y a déjà un compte FRANSAT avec cette adresse email';

        this.$view = $view;

        this.$activityDomainInput = this.$view.find('.js-activity-domain');

        this.$activityDomainOtherInput = this.$view.find('.js-activity-domain-other');
        this.$activityDomainOtherField = this.$activityDomainOtherInput.closest('.form-group');

        this.$siretInput = this.$view.find('.js-siret');
        this.$siretLabel = this.$siretInput.closest('.form-group').find('label');

        this.$charterField = this.$view.find('.js-charter-field');
        this.$charterInput = this.$charterField.find('input');

        this.$linkingField = this.$view.find('.js-linking-field');
        this.$linkingInput = this.$linkingField.find('input');

        this.$boostField = this.$view.find('.js-boost-field');

        this.$errorMessage = this.$view.find('.js-google-error');

        this.$occupationInput = this.$view.find('.js-occupation');

        this.$occupationOtherInput = this.$view.find('.js-occupation-other');
        this.$occupationOtherField = this.$occupationOtherInput.closest('.form-group');

        this.$infoLinking = this.$view.find('.js-info-linking');
        this.$infoFransatPro = this.$view.find('.js-info-fransat-pro');

        this.$intraCommunityVATInput = this.$view.find('.js-intra-community-vat');
        this.$intraCommunityVATLabel = this.$intraCommunityVATInput.closest('.form-group').find('label');

        this.render();
        this.bind();
    }

    bind() {
        this.$activityDomainInput.on('change', '[type=checkbox]', (e) => {
            const $e = $(e.currentTarget);

            if ($e.prop('checked')) {

                // if exclusive checked => uncheck all expect this one
                if ($e.data('exclusive')) {
                    this.$activityDomainInput.find('[type=checkbox]').prop('checked', false);
                    $e.prop('checked', true);
                } else {
                    // if non exclusive checked => uncheck exclusive
                    this.$activityDomainInput.find('[type=checkbox][data-exclusive=1]').prop('checked', false);
                }
            }
            this.renderActivity();
            this.renderSiret();
            this.renderCharter();
            this.renderBoost();
        });
        this.$occupationInput.on('change', () => this.renderOccupation());

        this.$view.on('click', '.js-use-linking [type=radio]', (e) => {
            this.renderLinking(e.target);
        });

        this.$view.on('click', '.js-is-pro [type=radio]', (e) => {
            this.togglePro(e.target);
        });

        this.$infoLinking.popover();
        this.$infoFransatPro.popover();
    }

    render() {
        this.renderActivity();
        this.renderSiret();
        this.renderCharter();
        this.renderLinking(this.$view.find('.js-use-linking [type=radio][checked=checked]')[0]);
        this.renderBoost();
        this.renderOccupation();
        this.renderError();
    }

    renderActivity() {
        if (this.$activityDomainInput.find('[type=checkbox][value=other]').prop('checked')) {
            this.$activityDomainOtherField.fadeIn();
            this.$activityDomainOtherInput.prop('required', true);
            this.$intraCommunityVATInput.prop('required', false);
            this.$intraCommunityVATLabel.removeClass('required')
        } else {
            this.$activityDomainOtherField.fadeOut();
            this.$activityDomainOtherInput.val('');
            this.$activityDomainOtherInput.prop('required', false);
            this.$intraCommunityVATInput.prop('required', true);
            this.$intraCommunityVATLabel.addClass('required');
        }
    }

    renderOccupation() {
        if (this.$occupationInput.val() === 'AUTRE') {
            this.$occupationOtherField.fadeIn();
            this.$occupationOtherInput.prop('required', true);
        } else {
            this.$occupationOtherField.fadeOut();
            this.$occupationOtherInput.val('');
            this.$occupationOtherInput.prop('required', false);
        }
    }

    renderSiret() {
        if (this.$activityDomainInput.find('[type=checkbox][value=other]').prop('checked')) {
            this.$siretInput.prop('required', false);
            this.$siretLabel.removeClass('required');
        } else {
            this.$siretInput.prop('required', true);
            this.$siretLabel.addClass('required');
        }
    }

    renderCharter() {
        let isChecked = false;
        this.$view.find('[type=checkbox][data-charter=1]').each(function() {
            if ($(this).prop('checked')) {
                isChecked = true;
                return true;
            }
        });

        if (isChecked) {
            this.$charterField.fadeIn();
            this.$charterInput.prop('required', true);
        } else {
            this.$charterField.fadeOut();
            this.$charterInput.prop('required', false);
            this.$charterInput.prop('checked', false);
        }
    }

    renderLinking($elem) {
        let isChecked = false;
        if ($elem.value === "yes") {
            isChecked = true;
        }

        if (isChecked) {
            this.$linkingField.fadeIn();
            this.$linkingInput.prop('required', true);
        } else {
            this.$linkingField.fadeOut();
            this.$linkingInput.prop('required', false);
            this.$linkingInput.prop('checked', false);
        }
    }

    togglePro($elem) {
        let isChecked = false;
        if ($elem.value === "yes") {
            isChecked = true;
        }

        if (isChecked) {
            this.$activityDomainInput.find('[type=checkbox][data-with-pro=1]').prop('checked', true);
            this.$activityDomainInput.find('[type=checkbox][data-exclusive=1]').prop('checked', false);
        }

        this.renderActivity();
        this.renderSiret();
        this.renderCharter();
        this.renderBoost();
    }

    renderBoost() {
        let isChecked = false;
        this.$view.find('[type=checkbox][data-linking=1]').each(function() {
            if ($(this).prop('checked')) {
                isChecked = true;
                return true;
            }
        });

        if (isChecked) {
            this.$boostField.fadeIn();
        } else {
            this.$boostField.fadeOut();
            let $inputs = this.$view.find('.js-use-linking [type=radio]');
            $($inputs).each(function (key, input) {
                if (input.value === "no") {
                    $(input).prop('checked', true);
                } else {
                    $(input).prop('checked', false);
                }

            });
            this.renderLinking(this.$view.find('.js-use-linking [type=radio][checked=checked]')[0])

        }
    }

    renderError() {
        const parts = window.location.hash.split('#');
        for (let part of parts){
            if (part.startsWith(this.H_ERROR)){
                if (decodeURIComponent(part.substring(this.H_ERROR.length + 1)) === this.ERROR_MESSAGE || decodeURIComponent(part.substring(this.H_ERROR.length + 1)) === this.ERROR_MESSAGE_ALREADY_EXIST) {
                    this.$errorMessage.html(decodeURIComponent(part.substring(this.H_ERROR.length + 1)) + '. <a style="color: #b34242" href="/revendeurs/password_request">Vous avez oublié votre mot de passe ?</a>' );
                } else {
                    this.$errorMessage.html(decodeURIComponent(part.substring(this.H_ERROR.length + 1)) );
                }
                this.$errorMessage.removeClass('d-none');
            }
        }
    }

}
